var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLogoNoTextHeader = function SvgLogoNoTextHeader(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2065_15444_mobile)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 256C57.4254 256 0 198.575 0 128C0 57.4254 57.4254 0 128 0C198.575 0 256 57.4254 256 128C256 198.575 198.575 256 128 256ZM128 46.5455C83.0836 46.5455 46.5455 83.0836 46.5455 128C46.5455 172.916 83.0836 209.455 128 209.455C172.916 209.455 209.455 172.916 209.455 128C209.455 83.0836 172.916 46.5455 128 46.5455Z",
    fill: "url(#paint0_linear_2065_1544_mobile)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2065_1544_mobile",
    x1: 34.2421,
    y1: 37.7301,
    x2: 205.363,
    y2: 258.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#4FACFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#C471F5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2065_15444_mobile"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white"
  })))));
};
export default SvgLogoNoTextHeader;